import * as React from "react";
import { useState, useEffect } from "react";
import "./PatientList.css";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaFilter } from "react-icons/fa";
import { AiFillAppstore } from "react-icons/ai";
import Add from "@mui/icons-material/Add";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import PatientLogo from "../../Images/ClinicSVG/newdoctor.svg";

const PatientList = () => {
  // GET PATIENT DETAILS
  const [patientdetails, setpatientdetails] = useState([]);
  const savedtoken = localStorage.getItem("SavedToken");

  const [loading, setLoading] = useState(true);
  const DoctorName = localStorage.getItem("Username");
  const [latestweightdetails, setlatestweightdetails] = useState([]);

  useEffect(() => {
    axios
      .get(`https://djangoobesitychat.azurewebsites.net/user/latestwaightapi/`, {
        headers: {
          Authorization: `Token ${savedtoken}`,
        },
      })
      .then((response) => {
        setlatestweightdetails(response.data);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    axios
      .get(`https://djangoobesitychat.azurewebsites.net/patientresponse/${DoctorName}/`, {
        headers: {
          Authorization: `Token ${savedtoken}`,
        },
      })

      .then((response) => {
        setpatientdetails(response.data);
        // // // //console.log("ASD",response.data)
        setLoading(false);
      })
      .catch((err) => {});
  }, []);
  if (!patientdetails) return null;

  const combinedData =
    patientdetails.patient_list &&
    patientdetails.patient_list.map((revisitItem) => {
      const myPatientsItem =
        patientdetails.my_patients &&
        patientdetails.my_patients.find(
          (item) => item && item.patient_id2_id === revisitItem.patient_name__id
        );
      return myPatientsItem && { ...revisitItem, ...myPatientsItem };
    });
  const uniqueIds = [];
  const uniquePatients =
    combinedData &&
    combinedData.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.patient_name__id);

      if (!isDuplicate) {
        uniqueIds.push(element.patient_name__id);

        return true;
      }

      return false;
    });

    
    
    const combinedPatientDetails =
    uniquePatients &&
    uniquePatients.map((revisitItem) => {
  const myPatientsItem =
    latestweightdetails &&
    latestweightdetails.find(
      (item) => item && item.patient_name === revisitItem.patient_name__username
      );
      let PatientID = revisitItem.id
      // //console.log("myPatientsItem",myPatientsItem)
      return myPatientsItem
      ? { ...myPatientsItem,...revisitItem }
      : revisitItem;
    });
    //console.log("combinedPatientDetails", combinedPatientDetails);
    //console.log("uniquePatients", uniquePatients);





  const Row = (props) => {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    const SaveID = () => {
      localStorage.setItem("PatientID", row.id);
      localStorage.setItem("patientUserName", row.patient_name__username);
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }} onClick={SaveID}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <RemoveIcon /> : <AddIcon />}
            </IconButton>
          </TableCell>
          <TableCell align="center">
            <img
              src={PatientLogo}
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </TableCell>

          <Link to="/dashboard/personalPatientView">
            <TableCell align="center" style={{ cursor: "pointer" }}>
              {row.id}
            </TableCell>
            </Link>
            <TableCell align="center">
            {row.patient_name__firstName} {row.patient_name__lastName}
            </TableCell>
            
          <TableCell align="center">{row.age}</TableCell>
          <TableCell align="center">{Math.round(row.bmi)}</TableCell>
          <TableCell align="center">{row.current_weight}</TableCell>
          <TableCell align="center">{row.target_weight}</TableCell>

          {/*<TableCell align="center">{row.phenotype}</TableCell>*/}
          <TableCell align="center">
          {row.dispensed_drug &&
            row.dispensed_drug?.map((index) => (
              <h4>{index.medicine_name}</h4>
            ))}
            </TableCell>
          <TableCell align="center">{row.dosage}</TableCell>
          {/*<TableCell align="center">{row.patientcluster}</TableCell>*/}
          <TableCell align="center">{row.height}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <div className="coll-table-main-div">
                <div className="coll-table-id-div">
                  <h3>ID : </h3>

                  <p>#{row.id}</p>
                </div>

                <div className="coll-table-main-sub-div">
                  <div className="coll-table-sub-div-one">
                    <div className="coll-table-sub-one-section-one">
                      <h3>Gender:</h3> <p>{row.patient_name__gender}</p>
                    </div>
                    <div className="coll-table-sub-one-section-one">
                      <h3>Weight Beginning:</h3> <p>{row.beginning_weight}</p>
                    </div>
                    <div className="coll-table-sub-one-section-one">
                      <h3>% Match of phenotype:</h3>{" "}
                      <p>{row.percent_match_to_phenotype}</p>
                    </div>
                  </div>
                  <div className="coll-table-sub-div-one">
                    <div className="coll-table-sub-one-section-one">
                      <h3>Date of Birth:</h3>{" "}
                      <p>{row.patient_name__date_of_birth}</p>
                    </div>
                    <div className="coll-table-sub-one-section-one">
                      <h3>Progress % according to the plan:</h3>{" "}
                      <p>{row.progress_percent_according_to_plan}</p>
                    </div>
                  </div>
                  <div className="coll-table-sub-div-one">
                    <div className="coll-table-sub-one-section-one">
                      <h3>Patient Questionnaire:</h3>
                      <Link to="/dashboard/questionnaire">
                        <p
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        >
                          Click here
                        </p>
                      </Link>
                    </div>
                    <div className="coll-table-sub-one-section-one">
                      <h3>Patient Summary:</h3>
                      <Link to="/dashboard/patientsummary">
                        <p
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        >
                          Click here
                        </p>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <div>
      <div style={{ padding: "10px" }}>
        <div className="appointment-list-sub-div-one">
          <h3>Patient List</h3>
        </div>

        {loading ? (
          <Loader />
        ) : (
          <div style={{ marginTop: "20px", padding: "20px" }}>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead
                  sx={{ backgroundColor: "rgb(49, 163, 214)", color: "white" }}
                >
                  <TableRow>
                    <TableCell />
                    <TableCell component="th" scope="row" align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Image</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>ID</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>

                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Name</p>
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Age</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>BMI</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Weight Current</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Weight Target</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    {/*<TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Phenotype</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                        </TableCell>*/}
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Dispense Drug</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Dosage</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    {/* 
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Patient Cluster</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    */}
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <p>Height</p>{" "}
                        <BsThreeDotsVertical
                          style={{
                            cursor: "pointer",
                            color: "rgb(49,163,214)",
                          }}
                        />
                      </div>
                    </TableCell>
                    {/*<TableCell align="center"></TableCell>*/}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {combinedPatientDetails &&
                    combinedPatientDetails.map((row) => <Row key={row.id} row={row} />)}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientList;
